import React from 'react';
import { Button } from '../../Common';
import './ForgotPasswordSubmitted.css';

type ForgotPasswordSubmittedProps = {
  email?: string;
  onBackToSignIn?: () => void;
  className?: string;
};

const ForgotPasswordSubmitted: React.FC<ForgotPasswordSubmittedProps> = ({
  email = 'your email',
  onBackToSignIn,
  className = '',
}) => {
  return (
    <div className={`forgot-password-submitted-container ${className}`}>
      <div className="forgot-password-submitted-content">
        <h1 className="forgot-password-submitted-title">Forgot password</h1>
        
        <p className="forgot-password-submitted-message">
          We sent an email to {email}.{'\n'}
          Please follow the instructions in email to proceed.
        </p>
      </div>

      <Button
        type="button"
        onClick={onBackToSignIn}
        primary={false}
        bordered={false}
        size="full"
      >
        Back to Sign In
      </Button>
    </div>
  );
};

export default ForgotPasswordSubmitted;
